export const GET_USERS = 'users/GET_USERS';
export const GET_USERS_SUCCESS = 'users/GET_USERS_SUCCESS';
export const GET_USERS_FAIL = 'users/GET_USERS_FAIL';

export const ADD_ROLE_TO_USER = 'users/ADD_ROLE_TO_USER';
export const ADD_ROLE_TO_USER_SUCCESS = 'users/ADD_ROLE_TO_USER_SUCCESS';
export const ADD_ROLE_TO_USER_FAIL = 'users/ADD_ROLE_TO_USER_FAIL';

export const DELETE_USER_ROLE = 'users/DELETE_USER_ROLE';
export const DELETE_USER_ROLE_SUCCESS = 'users/DELETE_USER_ROLE_SUCCESS';
export const DELETE_USER_ROLE_FAIL = 'users/DELETE_USER_ROLE_FAIL';

export const GET_AUTH_USERS = 'users/GET_AUTH_USERS'

export const LOGOUT_USER = 'users/LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'users/LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAIL = 'users/LOGOUT_USER_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/users.js